"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.chapterPalette = void 0;
var palette_1 = require("../../shared/palette");
var palette = {
    primary: {
        '100': '#E7EDFC',
        '300': '#BFC8DB',
        '500': '#112144',
        '700': '#0B1938',
        '900': '#071126',
    },
    secondary: {
        '100': '#E7E9EF',
        '300': '#BABED1',
        '500': '#182464',
        '700': '#131D50',
        '900': '#0E163C',
    },
    tertiary: {
        '100': '#E5EFF4',
        '300': '#B3D1DE',
        '500': '#006390',
        '700': '#004F73',
        '900': '#003B56',
    },
    neutrals: __assign(__assign({}, palette_1.commonNeutrals), { '100': '#F0F1F2', '300': '#D7D7D9', '500': '#A9AAAB', '700': '#6B6C6E', '900': '#464647' }),
    text: __assign(__assign({}, palette_1.commonTextColors), { disabled: '#A9AAAB', tertiary: '#6B6C6E', secondary: '#464647', primary: '#112144', interactive: '#68254D' }),
    accent01: {
        '100': '#FFF2F2',
        '300': '#E4BEBD',
        '500': '#7D373B',
        '700': '#68282C',
        '900': '#581B1F',
    },
    accent02: {
        '100': '#FFF3E5',
        '300': '#F7E3CC',
        '500': '#FBD8B2',
        '700': '#DFA567',
        '900': '#A05300',
    },
    accent03: {
        '100': '#F7EDF2',
        '300': '#E7C3D9',
        '500': '#A77995',
        '700': '#7B4164',
        '900': '#68254D',
    },
    accent04: {
        '100': '#F7E6E6',
        '300': '#DDC3C4',
        '500': '#895A5C',
        '700': '#613335',
        '900': '#421D1E',
    },
    success: __assign(__assign({}, palette_1.commonSuccess), { '700': '#027356' }),
    error: __assign({}, palette_1.commonError),
    warning: __assign({}, palette_1.commonWarning),
    info: __assign({}, palette_1.commonInfo),
    background: __assign(__assign(__assign({}, palette_1.commonBackgroundColors), palette_1.commonGradients), { neutral: '#FFF2F2', light: '#FFFBEE', lightTwo: '#F7EDF2', lightThree: '#F7E6E6', dark: '#112144', darkTwo: '#6A4647', neutralGradient: 'linear-gradient(180deg, #F0E9E5 0%, #FAF2EE 70%)', lightGradient: 'linear-gradient(180deg, #E4BEBD 0%, #FFF2F2 100%)', lightTwoGradient: 'linear-gradient(180deg, #E7C3D9 0%, #FFF4F4 70%)', lightThreeGradient: 'linear-gradient(180deg, #CEA7A8 0%, #FDF3F3 70%)', darkGradient: 'linear-gradient(165deg, #17225E 4.91%, #192669 89.46%)', ODPHeroGradient: 'linear-gradient(97deg, rgba(0, 40, 85, 0.85) 33.86%, rgba(0, 40, 85, 0.00) 73.68%)', teamTagBrandColor: '#CE0059' }),
};
exports.chapterPalette = {
    primary: {
        lightest: palette.primary[100],
        light: palette.primary[300],
        main: palette.primary[500],
        dark: palette.primary[700],
        darkest: palette.primary[900],
    },
    secondary: {
        lightest: palette.secondary[100],
        light: palette.secondary[300],
        main: palette.secondary[500],
        dark: palette.secondary[700],
        darkest: palette.secondary[900],
    },
    tertiary: {
        lightest: palette.tertiary[100],
        light: palette.tertiary[300],
        main: palette.tertiary[500],
        dark: palette.tertiary[700],
        darkest: palette.tertiary[900],
    },
    neutrals: {
        white: palette.neutrals.white,
        neutral: palette.neutrals[100],
        primary: palette.neutrals[300],
        disabled: palette.neutrals[500],
        secondary: palette.neutrals[900],
        tertiary: palette.neutrals[700],
    },
    text: {
        primary: palette.text.primary,
        secondary: palette.text.secondary,
        tertiary: palette.text.tertiary,
        light: palette.text.light,
        disabled: palette.text.disabled,
        interactive: palette.text.interactive,
    },
    accent01: {
        lightest: palette.accent01[100],
        light: palette.accent01[300],
        main: palette.accent01[500],
        dark: palette.accent01[700],
        darkest: palette.accent01[900],
    },
    accent02: {
        lightest: palette.accent02[100],
        light: palette.accent02[300],
        main: palette.accent02[500],
        dark: palette.accent02[700],
        darkest: palette.accent02[900],
    },
    accent03: {
        lightest: palette.accent03[100],
        light: palette.accent03[300],
        main: palette.accent03[500],
        dark: palette.accent03[700],
        darkest: palette.accent03[900],
    },
    accent04: {
        lightest: palette.accent04[100],
        light: palette.accent04[300],
        main: palette.accent04[500],
        dark: palette.accent04[700],
        darkest: palette.accent04[900],
    },
    success: {
        light: palette.success[300],
        main: palette.success[500],
        dark: palette.success[700],
    },
    error: {
        light: palette.error[300],
        main: palette.error[500],
        dark: palette.error[700],
    },
    warning: {
        light: palette.warning[300],
        main: palette.warning[500],
        dark: palette.warning[700],
    },
    info: {
        light: palette.info[300],
        main: palette.info[500],
        dark: palette.info[700],
    },
    backgrounds: __assign({}, palette.background),
};
